import PropTypes from 'prop-types';
import { actorLanguages, modelAvatar } from './Helper.js';
import Flux from '../../../../flux/Flux.js';
import ReloadHelper from '../../../../utils/ReloadHelper.js';
import style from './Tile.module.less';

const ActorTileV2 = (props) => {
	const onClickActor = (e) => {
		ReloadHelper.reload(props.data.profileLink, e);
	};

	return (
		<div>
			<a className={props.wrapperClasses} onClick={onClickActor} href={props.data.linkVX || props.data.profileLink}>
				<img src={props.data.previewPicture} loading={props.lazyLoad ? 'lazy' : 'eager'} />
				{modelAvatar(props.data, props.avatarSize, props.showOfflineBorder, props.showAge)}
				{props.badges && <div className={style.tileBadges}>{props.badges}</div>}

				{actorLanguages(props.data.spokenLanguages, props.data.name)}
				{props?.button && <div className={style.buttonWrapper}> {props.button} </div>}
			</a>
			{props.tilePlate && props.tilePlate}
		</div>
	);
};

ActorTileV2.propTypes = {
	data: PropTypes.object,
	wrapperClasses: PropTypes.string,
	badges: PropTypes.array,
	avatarSize: PropTypes.oneOf(Object.values(Flux.Constants.Grid2.ModelAvatar.Size)),
	showOfflineBorder: PropTypes.bool,
	showAge: PropTypes.bool,
	tilePlate: PropTypes.element,
	lazyLoad: PropTypes.bool,
	button: PropTypes.element,
};

ActorTileV2.defaultProps = {
	badges: [],
	avatarSize: Flux.Constants.Grid2.ModelAvatar.Size.MD,
	showOfflineBorder: false,
	showAge: false,
	tilePlate: null,
	lazyLoad: false,
};

export default ActorTileV2;
